<div id="sidebar" class="sidebar">
  <div class="menu-header"><span class="logo-text">{{marketName}}</span></div>
  <nav class="nav flex-column" id="sidebarMenu">
    <!-- Dashboard -->
    <a class="nav-link mainMenu" routerLink="/dashboard">
      <img src="./assets/images/dashboard.svg" style="width: 1.1rem;" class="img-fluid me-2" />
      <span class="nav-text">Dashboard</span>
    </a>

    <!-- Maintenance -->
    <div class="nav-item">
      <a class="nav-link mainMenu" role="button" (click)="toggleMenu('maintenanceMenu')"
        [attr.aria-expanded]="openMenus.has('maintenanceMenu')">
        <img src="./assets/images/maintenance.svg" style="width: 1.1rem;" class="img-fluid me-2" />
        <span class="nav-text">Maintenance</span>
        <i class="bi bi-chevron-right rotate-icon" [class.rotate]="openMenus.has('maintenanceMenu')"></i>
      </a>

      <div class="collapse submenu" id="maintenanceMenu">
        <ul class="nav flex-column">
          <li>
            <a class="nav-link" [routerLink]="['/ops/maintenance/market-info']">Market Information</a>
          </li>

          <li>
            <a class="nav-link" role="button" (click)="toggleSubMenu('settings', 'maintenanceMenu')"
              [attr.aria-expanded]="openSubMenus.has('settings')">
              <span class="nav-text">Settings</span>
              <i class="bi bi-chevron-right rotate-icon" [class.rotate]="openSubMenus.has('settings')"></i>
            </a>

            <div class="collapse submenu" id="settings">
              <ul class="nav flex-column">
                <li><a class="nav-link" [routerLink]="['/ops/maintenance/rental-settings']">Rental Settings</a></li>
                <li><a class="nav-link" [routerLink]="['/ops/maintenance/pos-settings']">POS Settings</a></li>
                <li><a class="nav-link" [routerLink]="['/ops/maintenance/printer-settings']">Printer Settings</a></li>
                <li><a class="nav-link" [routerLink]="['/ops/maintenance/vendor-settings']">{{'Vendor' | wordReplace}}
                    Settings</a></li>
                <li><a class="nav-link" [routerLink]="['/ops/maintenance/payment-settings']">Online Payment Settings</a>
                </li>
                <li><a class="nav-link" [routerLink]="['/ops/maintenance/email-settings']">Email Settings</a>
                </li>
                <li><a class="nav-link" [routerLink]="['/ops/maintenance/mandatory-fields']">Mandatory Fields</a></li>
                <li><a class="nav-link" [routerLink]="['/ops/maintenance/wi-settings']">WI Settings</a></li>
              </ul>
            </div>
          </li>

          <li><a class="nav-link" [routerLink]="['/ops/maintenance/revenue-category']">Revenue Category</a></li>
          <li *ngIf="!noLayout"><a class="nav-link" [routerLink]="['/ops/maintenance/booth-types']"> {{ 'Booth Types' |
              wordReplace }}</a> </li>
          <li *ngIf="noLayout"> <a class="nav-link" [routerLink]="['/ops/maintenance/booth-maintenance']"> {{ 'Booth
              Maintenance' | wordReplace}} </a> </li>
          <li><a class="nav-link" [routerLink]="['/ops/maintenance/layout-parts']">Layout Parts</a></li>
          <li *ngIf="!noLayout"> <a class="nav-link" [routerLink]="['/ops/maintenance/layout']">Layout </a> </li>
          <li><a class="nav-link" [routerLink]="['/ops/maintenance/product-category']">Product Category</a></li>
          <li><a class="nav-link" [routerLink]="['/ops/maintenance/product']">Product</a></li>
          <li><a class="nav-link" [routerLink]="['/ops/maintenance/other-charges']">Other Charges</a></li>
          <li><a class="nav-link" [routerLink]="['/ops/maintenance/cd-cards']">Credit / Debit Card</a></li>
          <li><a class="nav-link" [routerLink]="['/ops/maintenance/email-templates']">Email Templates</a></li>
          <li><a class="nav-link" [routerLink]="['/ops/maintenance/sales-person']">Sales Person</a></li>
          <li><a class="nav-link" [routerLink]="['/ops/maintenance/pos-terminals']">POS Terminals</a></li>
          <li><a class="nav-link" [routerLink]="['/ops/maintenance/user']">User</a></li>
          <li *ngIf="userName?.toLowerCase() === 'admin'">
            <a class="nav-link" [routerLink]="['/ops/maintenance/utilities']"> Utilities</a>
          </li>
        </ul>
      </div>
    </div>

    <!-- Rentals / Renewal -->
    <div class="nav-item">
      <a class="nav-link mainMenu" role="button" (click)="toggleMenu('RentalMenu')"
        [attr.aria-expanded]="openMenus.has('RentalMenu')">
        <img src="./assets/images/rentals-menu.svg" style="width: 1.1rem;" class="img-fluid me-2" />
        <span class="nav-text">Rentals / Renewal</span>
        <i class="bi bi-chevron-right rotate-icon" [class.rotate]="openMenus.has('RentalMenu')"></i>
      </a>

      <div class="collapse submenu" id="RentalMenu">
        <ul class="nav flex-column">
          <li><a class="nav-link" [routerLink]="['/ops/vendors']">{{'Vendor' | wordReplace}} & Rentals</a></li>
          <li><a class="nav-link" [routerLink]="['/ops/vendors/arr']">Automatic Rent Renewal</a></li>
          <li *ngIf="!noLayout"><a class="nav-link" [routerLink]="['/ops/vendors/view-layout']">View Layout</a></li>
          <!-- <li><a class="nav-link" [routerLink]="['/ops/vendors/booth-history']">Booth History</a></li> -->
          <li><a class="nav-link" [routerLink]="['/ops/vendors/delete-rental']">Delete Rental</a></li>
          <li><a class="nav-link" [routerLink]="['/ops/vendors/void-transaction']">Void Transaction</a></li>
          <li><a class="nav-link" [routerLink]="['/ops/vendors/deposit-slip']">Deposit Slip</a></li>
          <li><a class="nav-link" [routerLink]="['/ops/vendors/ven-email']">{{'Vendor' | wordReplace}} Email</a></li>
          <li><a class="nav-link" [routerLink]="['/ops/vendors/ach-payment']">Process ACH Payment</a></li>
        </ul>
      </div>
    </div>

    <div class="nav-item">
      <a class="nav-link collapsed mainMenu" href="javascript:void(0)" role="button" aria-expanded="false"
        (click)="toggleMenu('PosMenu')" [attr.aria-expanded]="openMenus.has('PosMenu')">
        <img src="./assets/images/POS.svg" style="width: 1.1rem;" class="img-fluid me-2" />
        <span class="nav-text">Point of Sales</span>
        <i class="bi bi-chevron-right rotate-icon" [class.rotate]="openMenus.has('PosMenu')"></i>
      </a>
      <div class="collapse submenu" id="PosMenu">
        <ul class="nav flex-column">
          <li><a class="nav-link" [routerLink]="['/pos/possales']">POS</a></li>
          <li><a class="nav-link" [routerLink]="['/ops/pos/consignment-inventory']">Consignment Inventory</a></li>
          <li><a class="nav-link" [routerLink]="['/ops/pos/gift-certificates']">Gift Certificates</a></li>
          <li><a class="nav-link" [routerLink]="['/ops/pos/vendor-adjustments']">{{'Vendor Adjustments' |
              wordReplace}}</a></li>
          <li><a class="nav-link" [routerLink]="['/ops/pos/cash-drawer']">Opening Balance</a></li>
          <li><a class="nav-link" [routerLink]="['/ops/pos/day-end-process']">Day End Process</a></li>
          <li><a class="nav-link" [routerLink]="['/ops/pos/vendor-payout']">Vendors Payout</a></li>
          <li><a class="nav-link" [routerLink]="['/ops/pos/sold-items']">Sold Items Search</a></li>
          <li><a class="nav-link" [routerLink]="['/ops/pos/wish-list']">Wish List</a></li>
          <li>
            <a class="nav-link collapsed" href="javascript:void(0)" role="button" aria-expanded="false"
              (click)="toggleSubMenu('checkWriting', 'PosMenu')"
              [attr.aria-expanded]="openSubMenus.has('checkWriting')">
              <span class="nav-text">Check Writing</span>
              <i class="bi bi-chevron-right rotate-icon" [class.rotate]="openSubMenus.has('checkWriting')"></i>
            </a>
            <div class="collapse submenu" id="checkWriting">
              <ul class="nav flex-column">
                <li><a class="nav-link" [routerLink]="['/ops/pos/check-setup']">Check Setup</a></li>
                <li><a class="nav-link" [routerLink]="['/ops/pos/check-layout']">Check Layout</a></li>
                <li><a class="nav-link" [routerLink]="['/ops/pos/check-printing']">Check Printing</a></li>
              </ul>
            </div>
          </li>
          <li>
            <a class="nav-link collapsed" href="javascript:void(0)" role="button" aria-expanded="false"
              (click)="toggleSubMenu('arcadecash', 'PosMenu')" [attr.aria-expanded]="openSubMenus.has('arcadecash')">
              <span class="nav-text">Arcade Cash</span>
              <i class="bi bi-chevron-right rotate-icon" [class.rotate]="openSubMenus.has('arcadecash')"></i>
            </a>
            <div class="collapse submenu" id="arcadecash">
              <ul class="nav flex-column">
                <li><a class="nav-link" [routerLink]="['/ops/pos/dc-arcade-cash']">Debit / Credit</a></li>
                <li><a class="nav-link" [routerLink]="['/ops/pos/arcade-cash-de']">Day End</a></li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- Reports -->
    <div class="nav-item">
      <a class="nav-link mainMenu" role="button" (click)="toggleMenu('reportsMenu')"
        [attr.aria-expanded]="openMenus.has('reportsMenu')">
        <img src="./assets/images/report.svg" style="width: 1.1rem;" class="img-fluid me-2" />
        <span class="nav-text">Reports</span>
        <i class="bi bi-chevron-right rotate-icon" [class.rotate]="openMenus.has('reportsMenu')"></i>
      </a>

      <div class="collapse submenu" id="reportsMenu">
        <ul class="nav flex-column">
          <li><a class="nav-link" [routerLink]="['/ops/report/rental']">Rental Reports</a></li>
          <li><a class="nav-link" [routerLink]="['/ops/report/pos']">POS Reports</a></li>
          <li *ngIf="enableInventory"><a class="nav-link" [routerLink]="['/ops/report/inventory']">Inventory Reports</a>
          </li>
          <li><a class="nav-link" [routerLink]="['/ops/report/management']">Management Reports</a></li>
        </ul>
      </div>
    </div>

    <!-- Inventory -->
    <div class="nav-item" *ngIf="enableInventory">
      <a class="nav-link mainMenu" role="button" (click)="toggleMenu('inventoryMenu')"
        [attr.aria-expanded]="openMenus.has('inventoryMenu')">
        <img src="./assets/images/inventory.svg" style="width: 1.4rem;" class="img-fluid me-2" />
        <span class="nav-text">Inventory</span>
        <i class="bi bi-chevron-right rotate-icon" [class.rotate]="openMenus.has('inventoryMenu')"></i>
      </a>

      <div class="collapse submenu" id="inventoryMenu">
        <ul class="nav flex-column">
          <li><a class="nav-link" [routerLink]="['/ops/inventory/barcode-templates']">Barcode Templates</a></li>
          <li><a class="nav-link" [routerLink]="['/ops/inventory/new-inventory']">New Inventory</a></li>
          <li><a class="nav-link" [routerLink]="['/ops/inventory/stock-details']">Stock Details</a></li>
          <li><a class="nav-link" [routerLink]="['/ops/inventory/import-inventory']">Import Inventory</a></li>
          <li><a class="nav-link" [routerLink]="['/ops/inventory/inventory-search']">Inventory Search</a></li>
        </ul>
      </div>
    </div>

    <div class="nav-item">
      <a class="nav-link mainMenu" role="button" (click)="toggleMenu('qbInterfaceMenu')"
        [attr.aria-expanded]="openMenus.has('qbInterfaceMenu')">
        <img src="./assets/images/qb_interface.svg" style="width: 1.4rem;" class="img-fluid me-2" />
        <span class="nav-text">QB Interface</span>
        <i class="bi bi-chevron-right rotate-icon" [class.rotate]="openMenus.has('qbInterfaceMenu')"></i>
      </a>

      <div class="collapse submenu" id="qbInterfaceMenu">
        <ul class="nav flex-column">
          @if (useQboForCheckPrinting){
          <li><a class="nav-link" [routerLink]="['/ops/qb/settings']">QBO Settings</a></li>
          }
          <li><a class="nav-link" [routerLink]="['/ops/qb/mapping']">QB Mapping</a></li>
          <li><a class="nav-link" [routerLink]="['/ops/qb/iif-file']">IIF File for Checks</a></li>
        </ul>
      </div>
    </div>
  </nav>

</div>